import http from '@/utils/request';
import { API_BASE } from '@/config/index';

// 查看码单
export function uploadFile(data) {
  const url = `${API_BASE.open}/api/file/upload`;
  return http.post({
    url,
    data,
    loading: true,
  });
}
